import { useEffect } from 'react'

export const usePromptIfUnsaved = (hasChanges) => {
  useEffect(() => {
    if (!hasChanges) return

    const handleBeforeUnload = (e) => {
      e.preventDefault()
      e.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [hasChanges])
}
